/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import { getOverrideProps } from "./utils";
import {
  Badge,
  Button,
  Divider,
  Flex,
  Heading,
  Icon,
  Text,
  TextAreaField,
  View,
} from "@aws-amplify/ui-react";
export default function HealthSummaryAllergiesDerivatives(props) {
  const { overrides, ...rest } = props;
  return (
    <Flex
      gap="10px"
      direction="row"
      width="unset"
      height="unset"
      justifyContent="flex-start"
      alignItems="flex-start"
      overflow="hidden"
      position="relative"
      padding="0px 0px 0px 0px"
      backgroundColor="rgba(255,255,255,1)"
      {...getOverrideProps(overrides, "HealthSummaryAllergiesDerivatives")}
      {...rest}
    >
      <Flex
        gap="24px"
        direction="column"
        width="670px"
        height="unset"
        justifyContent="flex-start"
        alignItems="flex-start"
        shrink="0"
        position="relative"
        padding="32px 32px 32px 32px"
        backgroundColor="rgba(255,255,255,1)"
        {...getOverrideProps(overrides, "Card Area")}
      >
        <Flex
          gap="16px"
          direction="row"
          width="unset"
          height="unset"
          justifyContent="center"
          alignItems="center"
          shrink="0"
          alignSelf="stretch"
          position="relative"
          padding="0px 0px 0px 0px"
          {...getOverrideProps(overrides, "hsadcAllergy")}
        >
          <View
            width="50px"
            height="50px"
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            overflow="hidden"
            shrink="0"
            position="relative"
            padding="0px 0px 0px 0px"
            {...getOverrideProps(overrides, "hsacImage")}
          >
            <Icon
              width="50px"
              height="50px"
              viewBox={{ minX: 0, minY: 0, width: 50, height: 50 }}
              paths={[
                {
                  d: "M25 50C38.8071 50 50 38.8071 50 25C50 11.1929 38.8071 0 25 0C11.1929 0 0 11.1929 0 25C0 38.8071 11.1929 50 25 50Z",
                  fill: "rgba(33,208,195,1)",
                  fillRule: "nonzero",
                },
              ]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="0%"
              bottom="0%"
              left="0%"
              right="0%"
              {...getOverrideProps(overrides, "Vector41376630")}
            ></Icon>
            <View
              padding="0px 0px 0px 0px"
              width="22.58px"
              height="25px"
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="7.3%"
              bottom="42.7%"
              left="28.59%"
              right="26.25%"
              {...getOverrideProps(overrides, "Group41376631")}
            >
              <Icon
                width="1.62px"
                height="2.52px"
                viewBox={{
                  minX: 0,
                  minY: 0,
                  width: 1.6166999340057373,
                  height: 2.522265911102295,
                }}
                paths={[
                  {
                    d: "M1.6167 0L1.6167 2.52227L0 2.52227L0 0C0.267773 0.00585938 0.53711 0.00917912 0.808497 0.00917912C1.07979 0.00917912 1.34902 0.00585938 1.6167 0Z",
                    fill: "rgba(102,102,102,1)",
                    fillRule: "nonzero",
                  },
                ]}
                display="block"
                gap="unset"
                alignItems="unset"
                justifyContent="unset"
                position="absolute"
                top="89.91%"
                bottom="0%"
                left="46.42%"
                right="46.42%"
                {...getOverrideProps(overrides, "Vector41376632")}
              ></Icon>
              <Icon
                width="22.58px"
                height="22.58px"
                viewBox={{
                  minX: 0,
                  minY: 0,
                  width: 22.57978630065918,
                  height: 22.579689025878906,
                }}
                paths={[
                  {
                    d: "M11.2898 0C17.5248 0 22.5798 5.05498 22.5798 11.29C22.5798 17.525 17.5248 22.5797 11.2898 22.5797C5.05479 22.5797 0 17.525 0 11.29C-2.77556e-15 5.05498 5.05469 0 11.2898 0Z",
                    fill: "rgba(102,102,102,1)",
                    fillRule: "nonzero",
                  },
                ]}
                display="block"
                gap="unset"
                alignItems="unset"
                justifyContent="unset"
                position="absolute"
                top="0%"
                bottom="9.67%"
                left="0%"
                right="0%"
                {...getOverrideProps(overrides, "Vector41376633")}
              ></Icon>
            </View>
            <Icon
              width="19.65px"
              height="19.65px"
              viewBox={{
                minX: 0,
                minY: 0,
                width: 19.654102325439453,
                height: 19.65410041809082,
              }}
              paths={[
                {
                  d: "M9.82705 0C15.2542 0 19.6541 4.39981 19.6541 9.82705C19.6541 15.2543 15.2543 19.6541 9.82705 19.6541C4.39981 19.6541 0 15.2543 0 9.82705C0 4.39981 4.39981 0 9.82705 0Z",
                  fill: "rgba(33,208,195,1)",
                  fillRule: "nonzero",
                },
              ]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="10.23%"
              bottom="50.46%"
              left="31.51%"
              right="29.18%"
              {...getOverrideProps(overrides, "Vector41376634")}
            ></Icon>
            <Icon
              width="12.43px"
              height="12.43px"
              viewBox={{
                minX: 0,
                minY: 0,
                width: 12.431639671325684,
                height: 12.431640625,
              }}
              paths={[
                {
                  d: "M6.21582 12.4316C9.64872 12.4316 12.4316 9.64872 12.4316 6.21582C12.4316 2.78292 9.64872 0 6.21582 0C2.78292 0 0 2.78292 0 6.21582C0 9.64872 2.78292 12.4316 6.21582 12.4316Z",
                  fill: "rgba(254,254,254,1)",
                  fillRule: "nonzero",
                },
              ]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="17.45%"
              bottom="57.68%"
              left="38.74%"
              right="36.4%"
              {...getOverrideProps(overrides, "Vector41376635")}
            ></Icon>
            <Icon
              width="3.73px"
              height="16.43px"
              viewBox={{
                minX: 0,
                minY: 0,
                width: 3.7270500659942627,
                height: 16.432422637939453,
              }}
              paths={[
                {
                  d: "M0.625585 16.4324L3.10107 16.4324C3.44541 16.4324 3.72705 16.1436 3.72705 15.7909L3.72705 0.641599C3.72705 0.288865 3.44375 0 3.10107 0L0.625683 0C0.283203 0 2.53885e-08 0.290525 2.53885e-08 0.641599L2.53885e-08 15.7909C-9.76309e-05 16.1419 0.281542 16.4324 0.625585 16.4324Z",
                  fill: "rgba(102,102,102,1)",
                  fillRule: "nonzero",
                },
              ]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="58.49%"
              bottom="8.64%"
              left="47.44%"
              right="45.11%"
              {...getOverrideProps(overrides, "Vector41376636")}
            ></Icon>
            <Icon
              width="3.73px"
              height="1.74px"
              viewBox={{
                minX: 0,
                minY: 0,
                width: 3.727146863937378,
                height: 1.7437517642974854,
              }}
              paths={[
                {
                  d: "M3.72715 1.74375L3.72715 0.641504C3.72715 0.28916 3.44512 0 3.10137 0L0.62578 0C0.282226 0 0 0.289355 0 0.641504L0 1.74375L3.72715 1.74375Z",
                  fill: "rgba(254,254,254,1)",
                  fillRule: "nonzero",
                },
              ]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="57.3%"
              bottom="39.22%"
              left="47.44%"
              right="45.11%"
              {...getOverrideProps(overrides, "Vector41376637")}
            ></Icon>
            <Icon
              width="3.73px"
              height="1.74px"
              viewBox={{
                minX: 0,
                minY: 0,
                width: 3.727146863937378,
                height: 1.7419934272766113,
              }}
              paths={[
                {
                  d: "M3.72715 1.74199L3.72715 0.639942C3.72715 0.302442 3.46875 0.0232422 3.14473 0L3.14473 1.74199L3.72715 1.74199ZM0.582226 0C0.258593 0.0233398 0 0.30254 0 0.639942L0 1.74199L0.582226 1.74199L0.582226 0Z",
                  fill: "rgba(236,240,241,1)",
                  fillRule: "nonzero",
                },
              ]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="57.3%"
              bottom="39.22%"
              left="47.44%"
              right="45.11%"
              {...getOverrideProps(overrides, "Vector41376638")}
            ></Icon>
            <Icon
              width="25.57px"
              height="13.85px"
              viewBox={{
                minX: 0,
                minY: 0,
                width: 25.568828582763672,
                height: 13.84617805480957,
              }}
              paths={[
                {
                  d: "M10.7632 12.3149L4.24277 12.6273L0 4.7683L10.7185 4.17904C12.321 1.96361 13.4144 -0.170471 18.3809 0.0107794L18.377 1.05189L23.7655 0.994569C25.6211 0.906385 25.8971 3.96 23.8866 4.05531L23.6103 4.07933L23.5659 4.3309L24.323 4.27562C25.8651 4.13773 26.0933 7.0682 24.3389 7.22484L23.0213 7.40717L22.9904 7.62162L23.8379 7.51215C25.2571 7.38363 25.29 10.2784 23.7872 10.4501L22.7746 10.6172L22.7773 10.7731L23.1917 10.7687C24.6008 10.7102 24.4147 13.2984 23.0866 13.4398C21.4727 13.6122 21.3054 13.6017 19.6507 13.7195C17.3082 13.8014 11.7836 14.3444 10.7632 12.3149Z",
                  fill: "rgba(254,210,152,1)",
                  fillRule: "nonzero",
                },
              ]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="60.71%"
              bottom="11.6%"
              left="10.68%"
              right="38.18%"
              {...getOverrideProps(overrides, "Vector41376639")}
            ></Icon>
            <Icon
              width="21.92px"
              height="2.08px"
              viewBox={{
                minX: 0,
                minY: 0,
                width: 21.91777229309082,
                height: 2.0815846920013428,
              }}
              paths={[
                {
                  d: "M8.93203 0.463066L0.520898 0.759745C0.344727 0.589432 0.171191 0.416486 0 0.241095L9.12285 0.00486388C9.36309 -0.0313666 9.49619 0.143828 9.59316 0.231621C10.6968 2.80809 19.8302 1.2534 21.8622 1.2868L21.9178 1.28699C21.755 1.44148 21.5529 1.54666 21.3138 1.57195L21.3083 1.57264C18.6695 1.82527 10.5268 3.04598 8.93203 0.463066Z",
                  fill: "rgba(240,185,125,1)",
                  fillRule: "nonzero",
                },
              ]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="84.44%"
              bottom="11.39%"
              left="14.22%"
              right="41.94%"
              {...getOverrideProps(overrides, "Vector41376640")}
            ></Icon>
            <Icon
              width="2.34px"
              height="9.29px"
              viewBox={{
                minX: 0,
                minY: 0,
                width: 2.343261241912842,
                height: 9.28671932220459,
              }}
              paths={[
                {
                  d: "M2.1585 0.0667006L2.34326 9.27676L0.184277 9.28672L0 0L2.1585 0.0667006Z",
                  fill: "rgba(255,255,255,1)",
                  fillRule: "nonzero",
                },
              ]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="68.06%"
              bottom="13.37%"
              left="24.25%"
              right="71.06%"
              {...getOverrideProps(overrides, "Vector41376641")}
            ></Icon>
            <Icon
              width="12.09px"
              height="11.59px"
              viewBox={{
                minX: 0,
                minY: 0,
                width: 12.08544921875,
                height: 11.586037635803223,
              }}
              paths={[
                {
                  d: "M11.948 1.56026L12.0854 11.5042L7.40352 11.586C3.95059 8.53037 1.3498 4.53467 0 0L11.948 1.56026Z",
                  fill: "rgba(15,121,134,1)",
                  fillRule: "nonzero",
                },
              ]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="64.28%"
              bottom="12.55%"
              left="2.07%"
              right="73.76%"
              {...getOverrideProps(overrides, "Vector41376642")}
            ></Icon>
            <View
              padding="0px 0px 0px 0px"
              width="2.65px"
              height="1.2px"
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="84.17%"
              bottom="13.43%"
              left="18.41%"
              right="76.3%"
              {...getOverrideProps(overrides, "Group41376643")}
            >
              <Icon
                width="1.12px"
                height="1.15px"
                viewBox={{
                  minX: 0,
                  minY: 0,
                  width: 1.1194971799850464,
                  height: 1.1493693590164185,
                }}
                paths={[
                  {
                    d: "M1.11946 0.569066C1.12278 0.886546 0.87425 1.14612 0.56507 1.14934C0.255695 1.15247 0.00237478 0.897484 3.10253e-05 0.580394C-0.00319163 0.263304 0.245051 0.00324606 0.554231 2.34e-05C0.863703 -0.00280863 1.11683 0.251781 1.11946 0.569066Z",
                    fill: "rgba(250,210,77,1)",
                    fillRule: "nonzero",
                  },
                ]}
                display="block"
                gap="unset"
                alignItems="unset"
                justifyContent="unset"
                position="absolute"
                top="0%"
                bottom="4.17%"
                left="57.7%"
                right="0%"
                {...getOverrideProps(overrides, "Vector41376644")}
              ></Icon>
              <Icon
                width="1.12px"
                height="1.15px"
                viewBox={{
                  minX: 0,
                  minY: 0,
                  width: 1.1194980144500732,
                  height: 1.1493710279464722,
                }}
                paths={[
                  {
                    d: "M1.11947 0.569068C1.12279 0.886548 0.87425 1.14612 0.56507 1.14934C0.255695 1.15247 0.00237478 0.897485 3.10253e-05 0.580395C-0.00319163 0.263306 0.245051 0.00324768 0.554231 2.50239e-05C0.863703 -0.00290466 1.11683 0.251782 1.11947 0.569068Z",
                    fill: "rgba(250,210,77,1)",
                    fillRule: "nonzero",
                  },
                ]}
                display="block"
                gap="unset"
                alignItems="unset"
                justifyContent="unset"
                position="absolute"
                top="4.17%"
                bottom="0%"
                left="0%"
                right="57.7%"
                {...getOverrideProps(overrides, "Vector41376645")}
              ></Icon>
            </View>
            <View
              padding="0px 0px 0px 0px"
              width="19.02px"
              height="19.33px"
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="10.56%"
              bottom="50.79%"
              left="31.65%"
              right="30.32%"
              {...getOverrideProps(overrides, "Group41376646")}
            >
              <Icon
                width="8.83px"
                height="19.33px"
                viewBox={{
                  minX: 0,
                  minY: 0,
                  width: 8.827150344848633,
                  height: 19.328125,
                }}
                paths={[
                  {
                    d: "M8.82715 19.3281C3.90342 19.0282 0 14.8165 0 9.66406C0 4.51162 3.90352 0.299805 8.82715 0C8.3085 0.127148 7.80645 0.297754 7.32412 0.507519C3.63858 1.81455 0.989844 5.42002 0.989844 9.66406C0.989844 13.9081 3.63858 17.5136 7.32412 18.8206C7.80645 19.0303 8.3086 19.2009 8.82715 19.3281Z",
                    fill: "rgba(236,240,241,1)",
                    fillRule: "nonzero",
                  },
                ]}
                display="block"
                gap="unset"
                alignItems="unset"
                justifyContent="unset"
                position="absolute"
                top="0%"
                bottom="0%"
                left="0%"
                right="53.59%"
                {...getOverrideProps(overrides, "Vector41376647")}
              ></Icon>
              <Icon
                width="7.81px"
                height="17.98px"
                viewBox={{
                  minX: 0,
                  minY: 0,
                  width: 7.811036586761475,
                  height: 17.98359489440918,
                }}
                paths={[
                  {
                    d: "M0 17.9836C4.35693 17.7047 7.81104 13.7859 7.81104 8.9918C7.81104 4.19766 4.35693 0.278906 0 0C0.100488 0.0259766 0.200294 0.0538086 0.299415 0.0833984C4.30234 0.730078 7.37324 4.47148 7.37324 8.9918C7.37324 13.5121 4.30234 17.2535 0.299415 17.9002C0.200294 17.9299 0.100488 17.9577 0 17.9836Z",
                    fill: "rgba(236,240,241,1)",
                    fillRule: "nonzero",
                  },
                ]}
                display="block"
                gap="unset"
                alignItems="unset"
                justifyContent="unset"
                position="absolute"
                top="3.48%"
                bottom="3.48%"
                left="58.93%"
                right="0%"
                {...getOverrideProps(overrides, "Vector41376648")}
              ></Icon>
            </View>
            <Icon
              width="8.11px"
              height="8.11px"
              viewBox={{
                minX: 0,
                minY: 0,
                width: 8.108301162719727,
                height: 8.108301162719727,
              }}
              paths={[
                {
                  d: "M2.95322 0L5.15508 0L5.15508 2.95322L8.1083 2.95322L8.1083 5.15508L5.15508 5.15508L5.15508 8.1083L2.95322 8.1083L2.95322 5.15508L0 5.15508L0 2.95322L2.95322 2.95322L2.95322 0Z",
                  fill: "rgba(255,91,98,1)",
                  fillRule: "nonzero",
                },
              ]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              position="absolute"
              top="21.78%"
              bottom="62.01%"
              left="43.06%"
              right="40.72%"
              {...getOverrideProps(overrides, "Vector41376649")}
            ></Icon>
          </View>
          <Flex
            gap="44px"
            direction="row"
            width="unset"
            height="unset"
            justifyContent="flex-start"
            alignItems="flex-start"
            grow="1"
            shrink="1"
            basis="0"
            alignSelf="stretch"
            position="relative"
            padding="0px 0px 0px 0px"
            {...getOverrideProps(overrides, "hsacDetailsContainer")}
          >
            <Flex
              gap="8px"
              direction="column"
              width="unset"
              height="unset"
              justifyContent="flex-start"
              alignItems="flex-start"
              grow="1"
              shrink="1"
              basis="0"
              position="relative"
              padding="0px 0px 0px 0px"
              {...getOverrideProps(overrides, "hsacDetailsColumn41376651")}
            >
              <Heading
                width="unset"
                height="unset"
                shrink="0"
                level="3"
                children="Soy"
                {...getOverrideProps(overrides, "hsacTittle")}
              ></Heading>
              <Flex
                gap="8px"
                direction="row"
                width="unset"
                height="unset"
                justifyContent="flex-start"
                alignItems="flex-start"
                shrink="0"
                alignSelf="stretch"
                position="relative"
                padding="0px 0px 0px 0px"
                {...getOverrideProps(overrides, "hsacDetailsColumn41376653")}
              >
                <Badge
                  width="unset"
                  height="unset"
                  shrink="0"
                  size="small"
                  variation="default"
                  children="Severe"
                  {...getOverrideProps(overrides, "hsacStatusBadge")}
                ></Badge>
                <Badge
                  width="unset"
                  height="unset"
                  shrink="0"
                  size="small"
                  variation="default"
                  children="Hives"
                  {...getOverrideProps(overrides, "hsacReaction1Badge")}
                ></Badge>
                <Badge
                  width="unset"
                  height="unset"
                  shrink="0"
                  size="small"
                  variation="default"
                  children="Shortness of Breath"
                  {...getOverrideProps(overrides, "hsacReaction2Badge")}
                ></Badge>
                <Badge
                  width="unset"
                  height="unset"
                  shrink="0"
                  size="small"
                  variation="default"
                  children="Has Doctor Notes"
                  {...getOverrideProps(overrides, "hsacNotesFlagBadge")}
                ></Badge>
                <Badge
                  width="unset"
                  height="unset"
                  shrink="0"
                  size="small"
                  variation="error"
                  children="Anaphylactic"
                  {...getOverrideProps(overrides, "hsacDangerousBadge")}
                ></Badge>
              </Flex>
            </Flex>
          </Flex>
        </Flex>
        <Flex
          gap="12px"
          direction="row"
          width="unset"
          height="unset"
          justifyContent="center"
          alignItems="center"
          shrink="0"
          position="relative"
          padding="0px 0px 0px 0px"
          {...getOverrideProps(overrides, "hsadcCheckBox12")}
        >
          <Text
            fontFamily="Inter"
            fontSize="20px"
            fontWeight="400"
            color="rgba(48,64,80,1)"
            lineHeight="30px"
            textAlign="right"
            display="block"
            direction="column"
            justifyContent="unset"
            width="unset"
            height="unset"
            gap="unset"
            alignItems="unset"
            shrink="0"
            position="relative"
            padding="0px 0px 0px 0px"
            whiteSpace="pre-wrap"
            children="Tamari"
            {...getOverrideProps(overrides, "label48539323")}
          ></Text>
        </Flex>
        <Flex
          gap="12px"
          direction="row"
          width="unset"
          height="unset"
          justifyContent="center"
          alignItems="center"
          shrink="0"
          position="relative"
          padding="0px 0px 0px 0px"
          {...getOverrideProps(overrides, "hsadcCheckBox13")}
        >
          <Text
            fontFamily="Inter"
            fontSize="20px"
            fontWeight="400"
            color="rgba(48,64,80,1)"
            lineHeight="30px"
            textAlign="right"
            display="block"
            direction="column"
            justifyContent="unset"
            width="unset"
            height="unset"
            gap="unset"
            alignItems="unset"
            shrink="0"
            position="relative"
            padding="0px 0px 0px 0px"
            whiteSpace="pre-wrap"
            children="Tempeh"
            {...getOverrideProps(overrides, "label48539421")}
          ></Text>
        </Flex>
        <Flex
          gap="12px"
          direction="row"
          width="unset"
          height="unset"
          justifyContent="center"
          alignItems="center"
          shrink="0"
          position="relative"
          padding="0px 0px 0px 0px"
          {...getOverrideProps(overrides, "hsadcCheckBox14")}
        >
          <Text
            fontFamily="Inter"
            fontSize="20px"
            fontWeight="400"
            color="rgba(48,64,80,1)"
            lineHeight="30px"
            textAlign="right"
            display="block"
            direction="column"
            justifyContent="unset"
            width="unset"
            height="unset"
            gap="unset"
            alignItems="unset"
            shrink="0"
            position="relative"
            padding="0px 0px 0px 0px"
            whiteSpace="pre-wrap"
            children="Textured vegetable protein (TVP)"
            {...getOverrideProps(overrides, "label48539513")}
          ></Text>
        </Flex>
        <Flex
          gap="12px"
          direction="row"
          width="unset"
          height="unset"
          justifyContent="center"
          alignItems="center"
          shrink="0"
          position="relative"
          padding="0px 0px 0px 0px"
          {...getOverrideProps(overrides, "hsadcCheckBox15")}
        >
          <Text
            fontFamily="Inter"
            fontSize="20px"
            fontWeight="400"
            color="rgba(48,64,80,1)"
            lineHeight="30px"
            textAlign="right"
            display="block"
            direction="column"
            justifyContent="unset"
            width="unset"
            height="unset"
            gap="unset"
            alignItems="unset"
            shrink="0"
            position="relative"
            padding="0px 0px 0px 0px"
            whiteSpace="pre-wrap"
            children="Tofu"
            {...getOverrideProps(overrides, "label48539599")}
          ></Text>
        </Flex>
        <TextAreaField
          width="unset"
          height="unset"
          label="List Derivatives:"
          shrink="0"
          alignSelf="stretch"
          placeholder="Placeholder"
          size="default"
          isDisabled={false}
          labelHidden={false}
          variation="default"
          {...getOverrideProps(overrides, "hsadcOthersTextField")}
        ></TextAreaField>
        <Button
          width="unset"
          height="unset"
          shrink="0"
          size="default"
          isDisabled={false}
          variation="primary"
          children="Save"
          {...getOverrideProps(overrides, "hsadcSave")}
        ></Button>
        <Divider
          width="unset"
          height="1px"
          shrink="0"
          alignSelf="stretch"
          size="small"
          orientation="horizontal"
          {...getOverrideProps(overrides, "hsadcDivider")}
        ></Divider>
        <Flex
          gap="32px"
          direction="row"
          width="unset"
          height="unset"
          justifyContent="flex-start"
          alignItems="flex-start"
          shrink="0"
          position="relative"
          padding="0px 0px 0px 0px"
          {...getOverrideProps(overrides, "hsacViewFooter")}
        >
          <Flex
            gap="16px"
            direction="row"
            width="unset"
            height="unset"
            justifyContent="flex-start"
            alignItems="flex-start"
            shrink="0"
            position="relative"
            padding="0px 0px 0px 0px"
            {...getOverrideProps(overrides, "hsacViewFooterContainer")}
          >
            <View
              width="24px"
              height="24px"
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              overflow="hidden"
              shrink="0"
              position="relative"
              padding="0px 0px 0px 0px"
              {...getOverrideProps(overrides, "hsacIcon")}
            >
              <Icon
                width="17.59px"
                height="13.41px"
                viewBox={{
                  minX: 0,
                  minY: 0,
                  width: 17.59000015258789,
                  height: 13.40999984741211,
                }}
                paths={[
                  {
                    d: "M5.59 10.58L1.42 6.41L0 7.82L5.59 13.41L17.59 1.41L16.18 0L5.59 10.58Z",
                    fill: "rgba(67,168,84,1)",
                    fillRule: "nonzero",
                  },
                ]}
                display="block"
                gap="unset"
                alignItems="unset"
                justifyContent="unset"
                position="absolute"
                top="23.29%"
                bottom="20.83%"
                left="14.21%"
                right="12.5%"
                {...getOverrideProps(overrides, "Vector41376694")}
              ></Icon>
            </View>
            <Text
              fontFamily="Inter"
              fontSize="16px"
              fontWeight="400"
              color="rgba(48,64,80,1)"
              lineHeight="24px"
              textAlign="left"
              display="block"
              direction="column"
              justifyContent="unset"
              letterSpacing="0.01px"
              width="unset"
              height="unset"
              gap="unset"
              alignItems="unset"
              shrink="0"
              position="relative"
              padding="0px 0px 0px 0px"
              whiteSpace="pre-wrap"
              children="Last Update: 01/02/2024"
              {...getOverrideProps(overrides, "hsacLabel")}
            ></Text>
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
}
